import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { AccountService } from '@visiativ/digital-account-front';
import { AvatarComponent, StoreService } from '@visiativ/digital-components-kit';
import { UserProfileMenuComponent } from '../user-profile-menu/user-profile-menu.component';

@Component({
	selector: 'app-icon-menu',
	templateUrl: './icon-menu.component.html',
	styleUrls: ['./icon-menu.component.scss'],
	standalone: true,
	imports: [MatMenuTrigger, MatButton, AvatarComponent, MatIcon, MatMenu, UserProfileMenuComponent],
})
export class IconMenuComponent {
	public accountService = inject(AccountService);
	public storeService = inject(StoreService);
	public firstname: string = this.storeService.connectedUser?.firstname;
	public lastname: string = this.storeService.connectedUser?.lastname;
	public picture: string = this.storeService.connectedUser?.picture;
}
